<div class="rd-widget rd-widget-no-height-restriction widgetNoTopBorder">
  <table class="widget-small cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-small">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'federalState'" [align]="'left'"></widget-label></td>
        <td colspan="9" *ngIf="editMode"><input class="widget-input-text gridster-item-content" maxlength="255" [(ngModel)]="widgetData.federalState" (ngModelChange)="setDirtyFlag(true)" /></td>
        <td colspan="9" *ngIf="!editMode"><widget-value [align]="'right'">{{ widgetData.federalState }}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'district'" [align]="'left'"></widget-label></td>
        <td colspan="9" *ngIf="editMode"><input class="widget-input-text gridster-item-content" maxlength="255" [(ngModel)]="widgetData.district" (ngModelChange)="setDirtyFlag(true)" /></td>
        <td colspan="9" *ngIf="!editMode"><widget-value [align]="'right'">{{ widgetData.district }}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'city'" [align]="'left'"></widget-label></td>
        <td colspan="9" *ngIf="editMode"><input class="widget-input-text gridster-item-content" maxlength="255" [(ngModel)]="widgetData.city" (ngModelChange)="setDirtyFlag(true)" /></td>
        <td colspan="9" *ngIf="!editMode"><widget-value [align]="'right'">{{ widgetData.city }}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'postcode'" [align]="'left'"></widget-label></td>
        <td colspan="9" *ngIf="editMode"><input class="widget-input-text gridster-item-content" maxlength="255" [(ngModel)]="widgetData.postcode" (ngModelChange)="setDirtyFlag(true)" /></td>
        <td colspan="9" *ngIf="!editMode"><widget-value [align]="'right'">{{ widgetData.postcode }}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'populationCity'" [align]="'left'"></widget-label></td>
        <td colspan="9" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.populationCity || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="9" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.populationCity" [isNullable]="true" [decimals]=" 0" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
        </td>
      </tr>
    </tbody>
  </table>
</div>
